import { productRecommendationApi } from "./productRecommendationApi";

export interface Guardrail {
  id: string;
  name: string;
  description?: string;
  created?: string;
  updated?: string;
}

export interface GetGuardrailsResponse {
  data: Guardrail[];
}

const guardrailsApi = productRecommendationApi.injectEndpoints({
  endpoints: (builder) => ({
    getGuardrails: builder.query<GetGuardrailsResponse, null>({
      query: () => ({
        url: `guardrails`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetGuardrailsQuery, useLazyGetGuardrailsQuery } =
  guardrailsApi;
